import apiClient1 from "../apiClient/index";

export const apiUrl = process.env.REACT_APP_API_URL;

export const apiClient = apiClient1;
